import { render } from "./CceSubCategoriesEditing.vue?vue&type=template&id=53cb753b&ts=true"
import script from "./CceSubCategoriesEditing.vue?vue&type=script&lang=ts"
export * from "./CceSubCategoriesEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__